export default __webpack_public_path__ + "static/media/straight_2.91498c58.png";